import { getType } from 'is-what';

export {
  isBlob,
  isArray,
  isBoolean,
  isDate,
  isEmptyArray,
  isEmptyObject,
  isEmptyString,
  isError,
  isFullArray,
  isFile,
  isFullObject,
  isFullString,
  isFunction,
  isInstanceOf as is,
  isMap,
  isNaNValue as isNaN,
  isNegativeNumber as isNegative,
  isNull,
  isNullOrUndefined as isNothing,
  isNumber,
  isObject,
  isObjectLike,
  isOneOf,
  isPlainObject as isPlain,
  isPositiveNumber as isPositive,
  isPrimitive,
  isPromise,
  isRegExp,
  isSet,
  isString,
  isSymbol,
  isType,
  isUndefined,
  isWeakMap,
  isWeakSet,
} from 'is-what';

export const of = (value: unknown): string => getType(value).toLowerCase();
